const headerStyle = () => {
  if($('.module--page-head').length || $('body.post-type-archive-realworks_wonen').length || $('body.post-type-archive-realworks_nieuwbouw').length || $('body.post-type-archive-realworks_bog').length) {
        if (screen.width > 992) {
            if( $(window).scrollTop() > 50 ) {
                $('.header').addClass('header--fixed');
            } else {
                $('.header').removeClass('header--fixed');
            }
        }
  }else{
        $('.header').addClass('header--fixed');
  }
}

$(document).on('scroll', function(){
    headerStyle();
})

$( document ).ready(function() {
    headerStyle();
})
